import { io } from 'socket.io-client';
import { createContext } from 'react';

const URL = process.env.REACT_APP_BASE_URL;

const socket = io(URL, {
	transports: ['websocket', 'polling'],
});

const SocketContext = createContext({});

// eslint-disable-next-line react/prop-types
export const SocketProvider = ({ children }) => {
	return <SocketContext.Provider value={{ socket }}>{children}</SocketContext.Provider>;
};

export default SocketContext;
